<template>
  <div class="timestamp-converter">
    <h1>时间戳转换工具</h1>
    
    <div class="converter-container">
      <!-- 当前时间显示 -->
      <div class="current-time">
        <h3>当前时间</h3>
        <div class="time-display">{{ currentTime }}</div>
        <div class="timestamp-display">
          <span>时间戳：{{ currentTimestamp }}</span>
          <el-button size="small" @click="copyTimestamp">复制</el-button>
        </div>
      </div>

      <!-- 时间戳转日期时间 -->
      <div class="conversion-section">
        <h3>时间戳转日期时间</h3>
        <div class="input-group">
          <el-input v-model="timestampInput" placeholder="请输入时间戳" />
          <el-radio-group v-model="timestampUnit">
            <el-radio-button label="seconds">秒</el-radio-button>
            <el-radio-button label="milliseconds">毫秒</el-radio-button>
          </el-radio-group>
        </div>
        <div class="result">
          {{ timestampToDate || '转换结果将显示在这里' }}
        </div>
      </div>

      <!-- 日期时间转时间戳 -->
      <div class="conversion-section">
        <h3>日期时间转时间戳</h3>
        <div class="input-group">
          <el-date-picker
            v-model="dateTimeInput"
            type="datetime"
            placeholder="选择日期时间"
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </div>
        <div class="result" v-if="dateTimeInput">
          <div>秒级时间戳：{{ dateToTimestampSeconds }}</div>
          <div>毫秒级时间戳：{{ dateToTimestampMilliseconds }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'

// 当前时间相关
const currentTime = ref('')
const currentTimestamp = ref(0)
let timer

const updateCurrentTime = () => {
  const now = new Date()
  currentTime.value = dayjs(now).format('YYYY-MM-DD HH:mm:ss')
  currentTimestamp.value = Math.floor(now.getTime() / 1000)
}

onMounted(() => {
  updateCurrentTime()
  timer = setInterval(updateCurrentTime, 1000)
})

onUnmounted(() => {
  if (timer) clearInterval(timer)
})

// 复制时间戳
const copyTimestamp = async () => {
  try {
    await navigator.clipboard.writeText(currentTimestamp.value.toString())
    ElMessage.success('复制成功')
  } catch (error) {
    ElMessage.error('复制失败')
  }
}

// 时间戳转日期时间
const timestampInput = ref('')
const timestampUnit = ref('seconds')

const timestampToDate = computed(() => {
  if (!timestampInput.value) return ''
  
  try {
    const timestamp = parseInt(timestampInput.value)
    if (isNaN(timestamp)) return '无效的时间戳'
    
    const milliseconds = timestampUnit.value === 'seconds' ? timestamp * 1000 : timestamp
    return dayjs(milliseconds).format('YYYY-MM-DD HH:mm:ss')
  } catch (error) {
    return '转换失败'
  }
})

// 日期时间转时间戳
const dateTimeInput = ref('')

const dateToTimestampSeconds = computed(() => {
  if (!dateTimeInput.value) return ''
  return Math.floor(new Date(dateTimeInput.value).getTime() / 1000)
})

const dateToTimestampMilliseconds = computed(() => {
  if (!dateTimeInput.value) return ''
  return new Date(dateTimeInput.value).getTime()
})
</script>

<style scoped>
.timestamp-converter {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 80px;
}

.converter-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 20px;
}

.current-time {
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.time-display {
  font-size: 24px;
  margin: 10px 0;
  font-weight: bold;
  color: #409EFF;
}

.timestamp-display {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.conversion-section {
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
}

.input-group {
  display: flex;
  gap: 10px;
  margin: 15px 0;
  align-items: center;
}

.result {
  margin-top: 15px;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
  min-height: 40px;
  line-height: 40px;
}

h3 {
  margin: 0;
  color: #303133;
}

:deep(.el-input) {
  max-width: 300px;
}

:deep(.el-date-picker) {
  width: 100%;
  max-width: 300px;
}
</style> 